export const guid = () =>
  `${Math.random()
    .toString(36)
    .substr(2, 9)}-${new Date().getTime()}`;

export const getCurrentTimestamp = () => Math.floor(Date.now() / 1000);

export const IMG_URL_REGEX = /(http(s?):)([/|.|\w|\S|-])*\.(?:jpg|gif|png)/;
